<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Détails Disciple Emmaus" />
            <DisciplesEmmaiusDetails/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import DisciplesEmmaiusDetails from './DisciplesEmmaiusDetails.vue'


export default {
    name: 'DisciplesEmmaiusPage',
    components: {
        NavBar,
        PageTitle,
        DisciplesEmmaiusDetails,
        FooterComp,
    }
}
</script>